<template>
  <div class="contact">
    <div class="container">
      <div class="wrapper">
        <h1>Request Successful</h1>
        <p>
          We have received your request. We will review it and our team will get in touch with further instructions. 
          <br>
          <br>

          If you have any further questions please contact us
          <a href="mailto:hello@ludimos.com">hello@ludimos.com</a>
        </p>

        <div class="text-center">
          <router-link
            to="/coaches"
            class="primary-button cta cta-full-width-mobile"
          >
            Coaches List
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Contact",
  mounted() {
    // Tracking code
    this.$ma.trackEvent({
      fb_event: "Lead",
      category: "Coaching_Request",
      action: "Coaching_Request",
      label: "Request Success",
      type: "Request Success"
    });
  },
  metaInfo() {
    return {
      title: this.textEllipsis(`Ludimos - Coaching request`, 25),
      // meta: [{ name: "theme-color", content: this.getPrimaryHex }]
    };
  }
};
</script>
<style scoped lang="scss">
.contact-block {
  text-align: center;

  p {
    margin: 0;
  }
  i {
    font-size: 50px;
    color: #fff;
    margin: 30px 0;
    background: #6f44ff;
    padding: 20px;
    border-radius: 5px;
  }
  a {
    display: block;
  }
}
.contact-map {
  iframe {
    background: #fff;
    padding: 5px;
    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
  }
}
</style>
